import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import * as XLSX from "xlsx";

@Component({
  selector: "download-file-format-dialog",
  templateUrl: "./download-file-format-dialog.html",
  styleUrls: ["./download-file-format-dialog.scss"],
})
export class DownloadFileFormatDialog {
  constructor(
    public dialogRef: MatDialogRef<DownloadFileFormatDialog>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  downloadExcel() {
    let columnData = [];
    if (this.data === "BEGEOID") {
      columnData = [["BEGEOID"]];
    } else if (this.data === "END_CUSTOMER_ID") {
      columnData = [["END CUSTOMER GLOBAL HQ ID"]];
    } else if (this.data === "INDIVIDUAL_PRODUCT_LIST") {
      columnData = [["PRODUCT", "TYPE", "PAYOUT"]];
    } else if (this.data === "PRODUCT_LIST") {
      columnData = [["PRODUCT"]];
    } else if (this.data === "EXCEL_MERGE") {
      columnData = [["PRODUCT", "TYPE"]];
    } else if (this.data === "PRODUCT_SKUS") {
      columnData = [["PRODUCT SKUS"]];
    } else if (this.data === "PRODUCT_FAMILIES") {
      columnData = [["PRODUCT FAMILIES"]];
    } else if (this.data === "TARGETS_INDIVIDUAL") {
      columnData = [["USER", "TARGET"]];
    } else if (this.data === "TARGETS_COMPANY") {
      columnData = [["BEGEOID", "TARGET"]];
    } else if (this.data === "PARTICIPANT_INDIVIDUAL") {
      columnData = [["USERIDS"]];
    } else if (this.data === "PARTICIPANT_COMPANY") {
      columnData = [["BEGEOIDS"]];
    } else if (this.data === "UPLOAD_COMPLETION") {
      columnData = [["CCOID", "Date of completion (MM/DD/YYYY)"]];
    } else {
      return;
    }
    let workbook = XLSX.utils.book_new(),
      worksheet = XLSX.utils.aoa_to_sheet(columnData);
    workbook.SheetNames.push("First");
    workbook.Sheets["First"] = worksheet;
    let xlsbin = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "binary",
    });
    let buffer = new ArrayBuffer(xlsbin.length),
      array = new Uint8Array(buffer);
    for (let i = 0; i < xlsbin.length; i++) {
      array[i] = xlsbin.charCodeAt(i) & 0xff;
    }
    let xlsblob = new Blob([buffer], { type: "application/octet-stream" });
    let url = window.URL.createObjectURL(xlsblob),
      anchor = document.createElement("a");
    anchor.href = url;
    if (this.data === "BEGEOID") {
      anchor.download = "BEGEOID_LIST.xlsx";
    } else if (this.data === "END_CUSTOMER_ID") {
      anchor.download = "END_CUSTOMER_LIST.xlsx";
    } else if (this.data === "INDIVIDUAL_PRODUCT_LIST") {
      anchor.download = "PRODUCT_PAYOUTS.xlsx";
    } else if (this.data === "PRODUCT_LIST") {
      anchor.download = "PRODUCT_LIST.xlsx";
    } else if (this.data === "EXCEL_MERGE") {
      anchor.download = "PRODUCT_LIST_ANY_PRODUCT.xlsx";
    } else if (this.data === "PRODUCT_SKUS") {
      anchor.download = "PRODUCT_SKUS.xlsx";
    } else if (this.data === "PRODUCT_FAMILIES") {
      anchor.download = "PRODUCT_FAMILIES.xlsx";
    } else if (this.data === "TARGETS_INDIVIDUAL") {
      anchor.download = "TARGETS_INDIVIDUAL.xlsx";
    } else if (this.data === "TARGETS_COMPANY") {
      anchor.download = "TARGETS_COMPANY.xlsx";
    } else if (this.data === "PARTICIPANT_INDIVIDUAL") {
      anchor.download = "PARTICIPANT_INDIVIDUAL.xlsx";
    } else if (this.data === "PARTICIPANT_COMPANY") {
      anchor.download = "PARTICIPANT_COMPANY.xlsx";
    } else if (this.data === "UPLOAD_COMPLETION") {
      anchor.download = "Participation Challenge Completions Upload.xlsx";
    }
    anchor.click();
    window.URL.revokeObjectURL(url);
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
